import { useCallback } from "react";
import { useAppSelector } from "src/page/store";

export function useUserDisplayName() {
  const cache = useAppSelector((s) => s.userNames.cache);
  const resolvingIds = useAppSelector((s) => s.userNames.resolvingIds);
  const currentUserId = useAppSelector((s) => s.auth.userInfo?.id);

  return useCallback(
    (userId: string) => {
      if (!userId) return "Unknown";
      if (currentUserId && userId === currentUserId) return "You";
      if (userId === "SYSTEM") return "SYSTEM";
      if (cache[userId]) return cache[userId];
      if (resolvingIds.includes(userId)) return "Loading...";
      return "Unknown";
    },
    [cache, resolvingIds, currentUserId]
  );
}
